import { render, staticRenderFns } from "./ObservationsForm.vue?vue&type=template&id=3617a312"
import script from "./ObservationsForm.vue?vue&type=script&lang=js"
export * from "./ObservationsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports